import { createContext } from "react";
import { Platform } from "react-native";
import { useState } from "react";
import inAColors from "@/components/ui/gluestack-ui-provider/inaThemes";
export const GlobalState = createContext();

let lut = [];
for (let i = 0; i < 256; i++) {
  lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
}

export const guid7 = (pfx) => {
  const d0 = Math.random() * 0xffffffff | 0;
  const d1 = Math.random() * 0xffffffff | 0;
  const d2 = Math.random() * 0xffffffff | 0;
  const d3 = Math.random() * 0xffffffff | 0;
  // let pfx = lut[d0 & 0xff]
  pfx = pfx || lut[d0 & 0xff]
  return pfx + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
      lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
      lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
      lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
}

export const GlobalContext = (props) => {

  const [pushToken, setPushToken] = useState('');

  // console.log('InAColor', props.inAColor, inaColors[props.inAColor]);
  return (
    <GlobalState.Provider value={{guid7: guid7, isWeb: Platform.OS == 'web', token: [pushToken, setPushToken], inAColor: props.inAColor, inAColors: inAColors[props.inAColor]}}>
      {props.children}
    </GlobalState.Provider>
  )
}